import { Paper, Typography } from '@mui/material';
import _, { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import MedicationIcon from '@mui/icons-material/Medication';
import { useCallback, useEffect, useMemo, useState } from 'react';
import AgyleAccordion from '../../../../../components/ui/accordion/agyleAccordion';
import { AgyleTable, createAgyleTableColumn } from '../../../../../components/table/AgyleTable';
import MessageBox from '../../../../../util/messageBox';
import * as React from 'react';
import { StyledBadge } from '../../../../../components/header/patientInfo';
import { AlertIcon } from '../../../../../components/icons/icons';
import makeStyles from '@mui/styles/makeStyles';
import { alpha, Box } from '@material-ui/core';
import moment from 'moment/moment';
import config from '../../../../../app/config';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    test: {
        // marginLeft: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
    alert: {
        padding: '10px 0px',
        // borderBottom: '1px solid black',
    },
    alertType: {
        // textAlign: 'center',
        width: 200,

        // color: #ff9595;
        // font-weight: bold;
        // overflow-wrap: break-word;
        // margin-left: 0px;
        // margin-right: 0px;
        // text-overflow: ellipsis;
        // overflow-wrap: break-word;
        whiteSpace: 'break-spaces',
    },
    alertGroup: {
        fontWeight: 'bold',
        // color: theme.palette.warning.light,
        color: theme.palette.error.light,
    },
    alertGroupWithType: {
        paddingTop: '10px',
    },
    alertTimespan: {
        width: 200,
    },
    alertBoldText: {
        fontWeight: 'bold',
    },
    alertText: {
        paddingTop: '10px',
    },
}));

const PrescriptionPatientWarnings = ({ patient }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [expanded, setExpanded] = useState(false);
    const [alerts, setAlerts] = useState([]);

    useEffect(() => {
        if (patient?.patient?.alerts) {
            const filteredAlerts = _.filter(patient.patient.alerts, (alert) => !alert.hideInUI);
            setAlerts(filteredAlerts);
            if (filteredAlerts.length > 0) {
                setExpanded(true);
            }
        } else {
            setAlerts([]);
        }
    }, [patient?.patient?.alerts]);

    const alertTypeCellValueExtra = useCallback(
        (column, data) => {
            const alert = data;

            return (
                <div className={clsx(classes.alert, classes.alertType)}>
                    {alert.alertType == null ? '' : alert.alertType}
                    <div
                        className={clsx(classes.alertGroup, {
                            [classes.alertGroupWithType]: alert.alertType != null && alert.group != null,
                        })}
                    >
                        {alert.group == null ? '' : alert.group}
                    </div>
                </div>
            );
        },
        [t, classes],
    );

    const alertTimespanCellValueExtra = useCallback(
        (column, data) => {
            const alert = data;

            return (
                <div className={clsx(classes.alert, classes.alertTimespan)}>
                    {alert.startDate !== null && (
                        <div className={classes.alertBoldText}>
                            {'Since: ' + moment.utc(alert.startDate).format(config.defaultDateFormat)}
                        </div>
                    )}
                    {alert.endDate !== null && (
                        <div className={classes.alertBoldText}>
                            {'Until: ' + moment.utc(alert.endDate).format(config.defaultDateFormat)}
                        </div>
                    )}
                </div>
            );
        },
        [t, classes],
    );

    const alertCellValueExtra = useCallback(
        (column, data) => {
            const alert = data;

            return (
                <div className={classes.alert}>
                    <div className={classes.alertBoldText}>{alert.allergen == null ? '' : alert.allergen}</div>
                    <div className={alert.allergen == null ? '' : classes.alertText}>
                        {alert.description == null ? '' : alert.description}
                    </div>
                    <div className={classes.alertText}>{alert.comments == null ? '' : alert.comments}</div>
                </div>
            );
        },
        [t, classes],
    );

    const COLUMNS = useMemo(
        () => [
            createAgyleTableColumn('no', 'No.', 0, null, 'count', 'notSort', 'medium', 'center', true, false, 40),
            createAgyleTableColumn('type', 'Type', 1, 'alertType', '$custom', 'notSort', 'medium', 'left', true, false, 200, null, [
                alertTypeCellValueExtra,
            ]),
            createAgyleTableColumn('timespan', 'Timespan', 2, 'custom', '$custom', 'notSort', 'medium', 'left', true, false, 200, null, [
                alertTimespanCellValueExtra,
            ]),
            createAgyleTableColumn('alert', 'Alert', 3, 'alert', '$custom', 'notSort', 'medium', 'left', true, false, null, null, [
                alertCellValueExtra,
            ]),
        ],
        [alertTypeCellValueExtra, alertTimespanCellValueExtra, alertCellValueExtra],
    );

    return (
        <>
            <AgyleAccordion
                expanded={expanded}
                onChange={() => setExpanded((prevState) => !prevState)}
                label={t('Warnings')}
                // label={t('Warnings') + ` (${alerts.length})`}
                formBackground
                secondLabel={
                    <StyledBadge badgeContent={alerts.length} color={alerts.length === 0 ? 'secondary' : 'primary'}>
                        <AlertIcon color={alerts.length === 0 ? 'secondary' : 'warning'} />
                    </StyledBadge>
                }
                secondHeadingStyle={classes.test}
            >
                {isEmpty(alerts) && (
                    <Paper
                        elevation={0}
                        sx={{
                            p: 3,
                            textAlign: 'center',
                            borderRadius: 2,
                            borderColor: 'divider',
                            backgroundColor: 'transparent',
                        }}
                    >
                        <AlertIcon style={{ fontSize: 48 }} />
                        <Typography variant="h6" color="text.secondary" gutterBottom>
                            {t('No patient alerts')}
                        </Typography>
                    </Paper>
                )}
                {!isEmpty(alerts) && (
                    <AgyleTable
                        columns={COLUMNS}
                        data={alerts}
                        disableFilter
                        disabledAction
                    />
                )}
            </AgyleAccordion>
        </>
    );
};

export default PrescriptionPatientWarnings;
